/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_report': {
    width: 16,
    height: 16,
    viewBox: '0 0 48.55 55.75',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="none" _stroke="#c4c4c4" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"><path pid="0" d="M23.71 51.76H1V1h43.66v30.87"/><circle pid="1" cx="32.71" cy="39.9" r="9.49" transform="rotate(-45 32.716 39.898)"/><path pid="2" d="M39.42 46.61l8.13 8.14M28.08 42.38l2.55-3.73 2.99 3.73 3.73-5.65M10.39 11.44h25M10.39 19.44h25M10.39 27.44h10.66"/></g></g>'
  }
})
